var _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "453.5px",
    height: "686px",
    viewBox: "0 0 453.5 686",
    enableBackground: "new 0 0 453.5 686",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#FFFFFF",
    width: 453.5,
    height: 686
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7,
    y: 100.3,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 123.4,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 36.7,
    fill: "#B2B2B2",
    stroke: "#706F6F",
    strokeWidth: 1.2756,
    strokeMiterlimit: 10,
    width: 399.4,
    height: 6.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M25.5,47.2v493.1h0.2 c1.1,3,7.2,5.3,14.7,5.3s13.6-2.3,14.7-5.3h0.2V47.2H25.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M25.5,75.3c0,0,11.8,6.5,29.8,0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M55.2,47.2v493.1h0.2 c1.1,3,7.2,5.3,14.7,5.3s13.6-2.3,14.7-5.3H85V47.2H55.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M55.2,75.3c0,0,11.8,6.5,29.8,0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M85,47.2v493.1h0.2 c1.1,3,7.2,5.3,14.7,5.3c7.5,0,13.6-2.3,14.7-5.3h0.2V47.2H85z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M85,75.3c0,0,11.8,6.5,29.8,0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M114.8,47.2v493.1h0.2 c1.1,3,7.2,5.3,14.7,5.3c7.5,0,13.6-2.3,14.7-5.3h0.2V47.2H114.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M114.8,75.3c0,0,11.8,6.5,29.8,0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M144.5,47.2v493.1h0.2 c1.1,3,7.2,5.3,14.7,5.3c7.5,0,13.6-2.3,14.7-5.3h0.2V47.2H144.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M144.5,75.3c0,0,11.8,6.5,29.8,0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M174.3,47.2v493.1h0.2 c1.1,3,7.2,5.3,14.7,5.3s13.6-2.3,14.7-5.3h0.2V47.2H174.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#878787",
    strokeWidth: 0.8084,
    strokeMiterlimit: 10,
    d: "M174.3,75.3c0,0,11.8,6.5,29.8,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumHeight);
export default __webpack_public_path__ + "static/media/medium_height.93be6204a429eccd970e7c1ba8b467db.svg";
export { ForwardRef as ReactComponent };